import { render, staticRenderFns } from "./pageSize.vue?vue&type=template&id=cea0e7ce&scoped=true"
import script from "./pageSize.vue?vue&type=script&lang=js"
export * from "./pageSize.vue?vue&type=script&lang=js"
import style0 from "./pageSize.vue?vue&type=style&index=0&id=cea0e7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea0e7ce",
  null
  
)

export default component.exports